import {
  Filter
} from '../common/filter';

export class CurrentFilterDataService {
  constructor(
    $q,
    FilterDataFactory,
    FiltersService,
    CurrentModelService,
    AggregateDataService,
    ErrorHandlerService,
    CurrentFilterService,
    $timeout,
    $rootScope,
  ) {
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterService = CurrentFilterService;
    this.$q = $q;
    this.FilterDataFactory = FilterDataFactory;
    this.filterData = FilterDataFactory();
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.autoUpdate = true;
    this.needReload = false;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  reload(force) {
    //    console.log("reload, cache: " + force);
    const reload = [];
    if (this.autoUpdate || force ||
      this.CurrentFilterService.filterBar.drilldown[0] !==
      this.AggregateDataService.barDim) {
      reload.push(this.AggregateDataService.init(force));
    }
    if ((this.autoUpdate || force) && !this.CurrentFilterService.frameUrl) {
      reload.push(this.filterData.update(this.filter, force));
      if (this.filter.isDashboard) {
        if (!this.dashboardData) this.dashboardData = {};

        this.filter.children.forEach(f => {
          const dIndex = f.dIndex || f.id;
          if (!this.dashboardData[dIndex])
            this.dashboardData[dIndex] = this.FilterDataFactory();
          if (!f.cardMinimazed) {
            reload.push(this.dashboardData[dIndex].update(
              Object.assign(new Filter(), f, {
                'filters': this.filter.filters.concat(f.filters)
              })));
          }
        });
      }
      this.needReload = false;
    } else {
      this.needReload = true;
    }
    return this.$q.all(reload)
      .catch((error) => {
        this.ErrorHandlerService.handle(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/current-filter-data.service.js